import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useBundle } from '@amzn/react-arb-tools';
import { css, Global, useTheme } from '@emotion/react';
import Select, { SelectOption } from '@amzn/meridian/select';
import Column from '@amzn/meridian/column';
export const QuantitySelector = ({ options, quantity, setQuantity }) => {
    const theme = useTheme();
    const [bundle, isBundleLoading] = useBundle('pages.productDetails');
    const { minimum, maximum } = options;
    // Set the minimun so that the default number on the quantity bar updates correctly
    // This is also required for any updates when switching product variations
    React.useEffect(() => {
        setQuantity(minimum);
    }, [options]);
    if (isBundleLoading) {
        return null;
    }
    // Using emotions Global style sheet since the modal used in combination with the
    // Select component lives outside the component
    return (_jsxs(Column, { spacingInset: "400 350 none 350", children: [_jsx(Global, { styles: css `
          // Find the div that has the [role='listbox'] (aka selection list)
          body > div:has([role='listbox']) {
            [role='dialog'] {
              max-height: 55dvh;
              padding-inline-start: 1px;
              padding-inline-end: 1px;
              background-color: ${theme.rio.semantic.color.background.primary};

              button[aria-selected='false'] {
                background-color: ${theme.rio.semantic.color.background.primary};
                border-top: 1px solid ${theme.rio.semantic.color.border.primary};
                color: ${theme.rio.semantic.color.font.primary};

                // Fix button highlighting issue in chrome mobile viewpoint
                // https://stackoverflow.com/questions/45049873/how-to-remove-the-blue-highlight-of-button-on-mobile?rq=3
                -webkit-tap-highlight-color: transparent;
              }

              button[aria-selected='true'] {
                background-color: ${theme.rio.base.color.gray[theme.mode === 'dark' ? 300 : 1400]};
                border: 1px solid ${theme.rio.semantic.color.border.selected};
                color: ${theme.rio.semantic.color.font.primary};

                // Fix button highlighting issue in chrome mobile viewpoint
                // https://stackoverflow.com/questions/45049873/how-to-remove-the-blue-highlight-of-button-on-mobile?rq=3
                -webkit-tap-highlight-color: transparent;
              }
            }
          }

          #quantity-selector {
            background-color: ${theme.rio.semantic.color.background.secondary};
            border: solid 1px ${theme.rio.semantic.color.border.primary};

            // Overwrite Meridian's focus ring
            &::after {
              border: 2px solid ${theme.rio.semantic.color.interaction.primary};
            }
          }
        ` }), _jsx(Select, { id: "quantity-selector", "data-testid": "quantity-selector", value: quantity, onChange: setQuantity, valueLabel: (selection) => { var _a; return `${bundle.getMessage('quantity')}: ${((_a = selection[0]) === null || _a === void 0 ? void 0 : _a.label) || ''}`; }, children: Array.from({ length: Math.ceil((maximum || 10) + 1 - minimum) }, (_, i) => (_jsx(SelectOption, { value: minimum + i, label: minimum + i }, minimum + i))) })] }));
};
